import {Suspense, lazy, useState, useEffect} from 'react';
import ErrorBoundary from './ErrorBoundary';
interface ILoadable {
    loader: any;
    loading: any;
}

const loadedCache: any = {};
export const Loadable = ({
    loader,
    loading,
}: ILoadable) => {
    const resourceUrl = String(loader);
    const LazyComp = loadedCache[resourceUrl] || lazy(loader);

    // 缓存组件
    if (!loadedCache[resourceUrl]) {
        loadedCache[resourceUrl] = LazyComp;
    }

    const Loading = loading;
    return (props?: any) => {
        return <ErrorBoundary>
            <Suspense fallback={<Loading />}>
                <LazyComp {...props} />
            </Suspense>
        </ErrorBoundary>;
    };
};

export const importAsyncComponent = (loader: any, loadingComp?: any) => {
    return Loadable({
        loader,
        loading() {
            return loadingComp || <div></div>;
        },
    });
};


// 下边补个远程加载js的 —— 后续如移动端也支持，可以考虑抽到core包中
// 缓存存储
const loadedRemoteCache: any = {};
const loadRemoteComponent = (url: string, compName: string) => {
    return new Promise((resolve, reject) => {
        if (loadedRemoteCache[url]) {
            return resolve(loadedRemoteCache[url]);
        }

        const script = document.createElement('script');
        script.src = url;
        script.async = true;

        script.onload = () => {
            const remoteComponent = (window as any).remoteComponentsMap?.[compName];
            if (remoteComponent) {
                loadedRemoteCache[url] = remoteComponent;
                (window as any).remoteComponentsMap.compName = null; // 取值后进行重置
                resolve(remoteComponent);
            } else {
                reject(new Error('The remote component did not mount correctly.'));
            }
        };

        script.onerror = (err) => {
            reject(new Error(`Failed to load remote component from ${url}: ${err}`));
        };

        document.head.appendChild(script);
        return () => {
            document.head.removeChild(script);
        };
    });
};

export const LoadableRemote = ({remoteUrl, compName, loading: Loading}: {
    remoteUrl: string;
    compName: string;
    loading: any;
}) => {
    const [Component, setComponent] = useState<any>(null);
    const [error, setError] = useState<any>(null);

    useEffect(() => {
        let isMounted = true;

        loadRemoteComponent(remoteUrl, compName)
            .then((Comp) => {
                if (isMounted) {
                    setComponent(() => Comp);
                }
            })
            .catch((err) => {
                if (isMounted) {
                    setError(err);
                    console.error(err);
                }
            });

        return () => {
            isMounted = false;
        };
    }, [remoteUrl, compName]);

    if (error) {
        return <div>加载失败，请刷新重试</div>;
    }

    if (!Component) {
        return <Loading />;
    }

    return (
        <ErrorBoundary isRemote>
            <Component />
        </ErrorBoundary>
    );
};

export const importRemoteComponent = (remoteUrl: string, compName: string, loadingComp?: any): any => {
    return LoadableRemote({
        remoteUrl,
        compName,
        loading() {
            return loadingComp || <div></div>;
        },
    });
};
